import { render } from "./AddStory.vue?vue&type=template&id=35e37493"
import script from "./AddStory.vue?vue&type=script&lang=js"
export * from "./AddStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__